import type {
  BuyBackQuoteListing,
  QUOTES_GRADES_ENUM,
} from '@backmarket/http-api/src/api-specs-buyback/seller/buyback-quotes.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { GRADES_TRANSLATIONS_KEYS } from './WishList.types'
import translations from './Wishlist.translations'

export function getQuoteGradeName(grade: string): string {
  const i18n = useI18n()
  const quotesGradeName =
    GRADES_TRANSLATIONS_KEYS[grade as string as QUOTES_GRADES_ENUM]

  return i18n(translations[quotesGradeName as keyof typeof translations])
}

export function generateListingKey(listing: BuyBackQuoteListing): string {
  const priceToWin = listing.priceToWinBackbox
    ? listing.priceToWinBackbox.amount
    : '0'

  return `${listing.grade}-${listing.state}-${listing.hasBackbox}-${priceToWin}`
}
